import AnimatedNumber from "../Components/AnimatedNumber";

export default () => {
    return (
        <div className="relative xs:py-8 sm:py-8 md:py-16 lg:py-16">
            <div className="grid grid-cols-2 gap-y-20 lg:grid-cols-2 lg:gap-y-0 items-center justify-center lg:gap-x-8">
                <div>
                    <AnimatedNumber
                        from={0}
                        to={1381}
                        decimals={0}
                        addition="+"
                    />
                    <p className="uppercase font-bold text-white text-center xs:text-lg sm:text-lg md:text-lg lg:text-4xl mt-4">
                        Fysieke & mentale transformaties
                    </p>
                </div>
                {/* <div>
                    <AnimatedNumber
                        from={0}
                        to={1381}
                        decimals={0}
                        addition="+"
                    />
                    <p className="uppercase font-bold text-white text-center xs:text-lg sm:text-lg md:text-lg lg:text-4xl mt-4">
                        Mentale transformaties
                    </p>
                </div> */}
                <div>
                    <AnimatedNumber from={0} to={9.1} decimals={1} />
                    <p className="uppercase font-bold text-white text-center xs:text-lg sm:text-lg md:text-lg lg:text-4xl mt-4">
                        Gemiddelde beoordeling
                    </p>
                </div>
            </div>
        </div>
    );
};
